import { FC, memo } from 'react'
import styled from 'styled-components'
import Checkbox from '../Checkbox'

export type TDrawCategoryItemInfo = {
  id: string
  name: string
  isSelect: boolean
}

interface IFDrawCategoryItemProps {
  categoryItem: TDrawCategoryItemInfo
  onClick: (categoryItemId: string) => void
  className?: string
}

const DrawCategoryItem: FC<IFDrawCategoryItemProps> = ({
  categoryItem,
  onClick,
  className,
}) => {
  const { id, name, isSelect } = categoryItem

  const handleClick = () => {
    onClick(id)
  }

  return (
    <StyledWrapper onClick={handleClick} className={className}>
      <div className="item-content">
        <Checkbox checked={isSelect} className="checkbox" />
        <span>{name}</span>
      </div>
    </StyledWrapper>
  )
}

export default memo(DrawCategoryItem, (prev, next) => {
  return !(
    prev.categoryItem.isSelect !== next.categoryItem.isSelect ||
    prev.onClick !== next.onClick
  )
})

const StyledWrapper = styled.div`
  padding: 8px 0;
  transition: all 0.1s ease-in-out;

  :hover {
    cursor: pointer;
    color: ${(props) => props.theme.color.text_3};
  }

  .checkbox {
    margin-right: 7px;
    transition: all 0.1s ease-in-out;
  }

  .item-content {
    display: flex;
    align-items: center;
    font-size: 12px;
    font-weight: 500;
  }
`
